<section id="why-choose-us" class="max-w-[1160px] mx-auto">
  @defer(on viewport) {
  <header class="text-center">
    <h2 class="h3-responsive font-bold mb-5">
      <p>PEOPLE LOVE MONISFER</p>
    </h2>
    <p class="text-gray-500">We are proud to have the highest customer satisfaction.</p>
  </header>
  <section class="office flex flex-col gap-24 md:gap-3 md:flex-row items-center justify-between my-24">
    @for (testimonial of testimonials; track $index) {
    <testimonial-card [testimonial]="testimonial"></testimonial-card>
    }
  </section>
  }@placeholder {
  <div class="spinner-center">
    <mat-spinner></mat-spinner>
  </div>
  }
</section>
